var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInstagram = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6439 7.84766C32.2215 7.84766 31.0707 8.9984 31.0707 10.4208C31.0707 11.8433 32.2215 12.994 33.6439 12.994C35.0663 12.994 36.2171 11.8433 36.2171 10.4208C36.2171 8.9984 35.0663 7.84766 33.6439 7.84766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1692 11.1558C16.1917 11.1558 11.333 16.0145 11.333 21.9919C11.333 27.9694 16.1917 32.8281 22.1692 32.8281C28.1467 32.8281 33.0054 27.9694 33.0054 21.9919C33.0054 16.0145 28.1467 11.1558 22.1692 11.1558V11.1558ZM22.1692 28.9284C18.3494 28.9284 15.2328 25.8118 15.2328 21.9919C15.2328 18.1721 18.3494 15.0555 22.1692 15.0555C25.989 15.0555 29.1056 18.1721 29.1056 21.9919C29.1056 25.8118 25.989 28.9284 22.1692 28.9284V28.9284Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7664 43.984H13.2176C5.92953 43.984 0 38.0545 0 30.7664V13.2176C0 5.92953 5.92953 0 13.2176 0H30.7824C38.0705 0 44 5.92953 44 13.2176V30.7824C44 38.0705 38.0705 44 30.7824 44L30.7664 43.984ZM13.2176 4.13948C8.21504 4.13948 4.13948 8.21504 4.13948 13.2176V30.7824C4.13948 35.785 8.21504 39.8605 13.2176 39.8605H30.7824C35.785 39.8605 39.8605 35.785 39.8605 30.7824V13.2176C39.8605 8.21504 35.785 4.13948 30.7824 4.13948H13.2176Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInstagram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/instagram.eb529ae73e26a63619ca0b6825fc8f89.svg";